// extracted by mini-css-extract-plugin
export default {"button-group":"button-group_HFM8z","wechat-url-button":"wechat-url-button_v8sve","web-url-button":"web-url-button_RG7Ba"};